import { useCallback, useEffect, useState } from "react";
import { getPedidosUsuario } from "../service/cargarPorUsuarioService";

export function usePedidosUsuarioSemana(username, desde, hasta) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!username || !desde || !hasta) {
      setData([]);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const res = await getPedidosUsuario(username, desde, hasta);
      setData(res || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [username, desde, hasta]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refresh: fetchData };
}
